import { render } from "./BannerView.vue?vue&type=template&id=8ca7aa48&scoped=true"
const script = {}

import "./BannerView.vue?vue&type=style&index=0&id=8ca7aa48&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca7aa48"]])

export default __exports__